import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import logger from './logger';
import { persistStore, autoRehydrate } from 'redux-persist';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';

export default function configureStore(rootReducer, rootSaga, hashHistory, initialState = null) {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(routerMiddleware(hashHistory), sagaMiddleware, thunkMiddleware, logger), autoRehydrate()),
  );

  persistStore(store, { whitelist: ['devices', 'langs'] });
  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers');
      store.replaceReducer(nextRootReducer);
    });
  }
  const history = syncHistoryWithStore(hashHistory, store);
  return { store, history };
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js